// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3ZkE4","item":"PaymentsMobile_item__3mq-X","label":"PaymentsMobile_label__1TAJ0","amount":"PaymentsMobile_amount__26KDN"};